

import React, { useEffect, useRef, useState } from 'react';
import WizardServices from './WizardServices';
import DeleteDialogueBox from '../Common/deleteDialogue';

export function ContractWizardAdjustment(MainWizard: any) {

    let [searchFor, setsearchFor] = useState("");
    let [conAdditional, setcontractAdditional] = useState<any>([]);
    let [AdjustmentListing, setAdjustmentListing] = useState<any>([]);
    let [AdjustmentListingTemp, setAdjustmentListingTemp] = useState<any>([]);
    let [systemUses, setsystemUses] = useState<any>([]);
    let [systemFormats, setsystemFormats] = useState<any>([]);
    let [editRate, seteditRate] = useState<any>([]);
    const formValidation = useRef<HTMLDivElement>(null);
    let [systemRegions, setsystemRegions] = useState<any>([]);
    var [deleteJob, setdeleteJob] = useState<any>([]);
    let [deleteAlert, setDeleteAlert] = useState(false);
    let [saveAlert, setSaveAlert] = useState(false);

    let [contractAdjustmentType, setContractAdjustmentType] = useState<any>([]);

    useEffect(() => {
        console.log(MainWizard.data.code)

        if (MainWizard.data.code) {

            AdjustmentListingSearch();

            WizardServices.contractssystemUses(MainWizard.data.code.contractRefNum).then((value: any) => {
                setsystemUses(value)
            })

            WizardServices.contractssystemFormats({}).then((value: any) => {
                setsystemFormats(value)
            })

            WizardServices.contractssystemsystemRegions(MainWizard.data.code.contractRefNum).then((value: any) => {
                setsystemRegions(value)
            })

            WizardServices.contractAdjustmentType().then((value: any) => {
                setContractAdjustmentType(value)
            })


        }
    }, []);

    const AdjustmentListingSearch = () => {
        WizardServices.contractAdjustmentListing(MainWizard.data.code.contractRefNum).then((value: any) => {
            setAdjustmentListing(value)
            setAdjustmentListingTemp(value)
        })
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        console.log(inputs)

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    }

    useEffect(() => {
        seteditRate(editRate)
    }, [editRate]);

    const contractAdjustmentListingSearch = (e: any) => {

        console.log(e)
        if (e.length > 0) {
            var listSearch = AdjustmentListingTemp.filter((value: any) =>
                value.type.toLowerCase().includes(e.toLowerCase()) ||
                value.groupDesc.toLowerCase().includes(e.toLowerCase())
            );
            setAdjustmentListing(listSearch)
        } else {
            setAdjustmentListing(AdjustmentListingTemp)
        }

    };

    const onAdjustmentDelete = (e: any) => {
        deleteJob = e;
        setdeleteJob(deleteJob)
    }

    const saveAdjustment = () => {
        console.log(editRate)
        editRate.contractRefNum = MainWizard.data.code.contractRefNum;
        var validSave = handleFieldRequired(editRate);
        if (validSave) {
            WizardServices.contractAdjustmentSave(MainWizard.data.code.contractRefNum, editRate).then(() => {
                AdjustmentListingSearch();
            })
        }
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            WizardServices.contractAdjustmentDelete(MainWizard.data.code.contractRefNum, deleteJob.adjustmentId).then(() => {
                setDeleteAlert(true);
                AdjustmentListingSearch();
            })
            setTimeout(function () {
                setDeleteAlert(false);
            }, 3000);
        }

        setdeleteJob({});
    };

    const clearSForm = () => {
        editRate = []
        seteditRate({ ...editRate })
        const inputs: any = formValidation.current?.querySelectorAll('input');
        if (inputs) {
            Object.values(inputs).map((values: any) => {
                var fieldName: any = document.getElementById(values.id);
                if (fieldName) {
                    fieldName.style.border = "1px solid #47529d";
                }


            })
        }

    };

    const selectAdjustment =(e: any) =>{
        console.log(e)
        editRate = e 
        seteditRate({...editRate})
    }

    return (
        <div className="form-format">

            <div className='box  ws-12 mb'>

                <div className="box box-header ws-12 pull-left"> <h2>Contract Adjustment</h2> </div>

                <div className='box-content pLarge' ref={formValidation}>
                    <div className="ws-6 pt">
                        <label className='ws-12 text-bold'>Region*</label>
                        <div className="label-entries">
                            <select className='ws-11 full-height' value={editRate.territoryCode ?? ""} required
                                onChange={(e) => { seteditRate({ ...editRate, territoryCode: e.target.value }) }}>
                                <option value="">Choose region</option>

                                {systemRegions?.map((values: any, index: any) => {
                                    return (
                                        <option value={values.groupDesc} label={values.groupDesc} >{values.groupDesc}</option>
                                    )
                                })}

                            </select>
                        </div>
                    </div>

                    <div className="ws-6 pt">
                        <label className='ws-12 text-bold'>Format/Source Codes*</label>
                        <div className="label-entries">
                            <select className='full-height' value={editRate.format ?? ""} required
                                onChange={(e) => { seteditRate({ ...editRate, format: e.target.value }) }}>
                                <option value="">Choose Format/Source Codes</option>
                                {
                                    systemFormats?.map((values: any, index: any) => {
                                        return (
                                            <option value={values.formatDesc} label={values.formatDesc} >{values.formatDesc}</option>
                                        )
                                    })}

                            </select>
                        </div>
                    </div>

                    <div className="ws-6 ptl">
                        <label className='ws-12 text-bold'>Percentage*</label>
                        <div className="label-entries ws-10">
                            <input className="text-right" type="number" name="percentage" value={editRate.percentage ?? ""} onChange={(e) => { seteditRate({ ...editRate, percentage: e.target.value }) }} placeholder="Enter Percentage" />
                        </div>
                    </div>

                    <div className="ws-6 ptl">
                        <label className='ws-12 text-bold'>Adjustment Type*</label>
                        <div className="label-entries">
                            <select className='ws-11 full-height' value={editRate.type ?? ""} required onChange={(e) => { seteditRate({ ...editRate, type: e.target.value }) }}>
                                <option value="">Choose Type</option>
                                {
                                    contractAdjustmentType?.map((val: any) => {
                                        return (
                                            <option value={val?.value} label={val?.value} />
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className="ws-12 ptl">
                        <div className="ws-6 ptl">
                            <label className='ws-8 text-bold'>Adjustment Amount</label>
                            <div className="label-entries">
                                <input className="text-right" type="checkbox" name="adjustAmount" checked={editRate?.adjustAmount ?? false} value={editRate.adjustAmount ?? false} onChange={(e) => { seteditRate({ ...editRate, adjustAmount: e.target.value }) }} />
                            </div>
                        </div>

                        <div className="ws-6 ptl">
                            <label className='ws-10 text-bold'>Adjustment Qty</label>
                            <div className="label-entries">
                                <input className="text-right" type="checkbox" name="adjustQty" checked={editRate?.adjustQty ?? false} value={editRate.adjustQty ?? false} onChange={(e) => { seteditRate({ ...editRate, adjustQty: e.target.value }) }} />
                            </div>
                        </div>
                    </div>

                </div>

                <div className='box-footer'>
                    <button className="icon-btn edit" onClick={saveAdjustment}><i className="icon-save"></i> Save</button>
                    <button className="btn btn-pink" onClick={clearSForm}> Reset</button>
                </div>
            </div>

            <div className='box ws-12 mt'>
                <div className="box box-header">
                    <h2><i className="fa fa-table"></i><span>{AdjustmentListing.length} record(s) found</span></h2>
                </div>

                <div className="box-content">
                    {saveAlert && <div className="alert alert-success"> Adjustment has been saved successfully</div>}
                    {deleteAlert && <div className="alert alert-success"> Adjustment has been deleted successfully</div>}

                    <div className="form-horizontal row-fluid" >
                        <div className="form-format ws-8 pbl">
                            <label className="ws-12 pts mts pr text-bold" >Filter</label>

                            <div className="ws-9">
                                <input type="text" className="form-control ws-12" value={searchFor} placeholder="Search" id="rate"
                                    onChange={(e) => { setsearchFor(e.target.value); contractAdjustmentListingSearch(e.target.value) }} />
                            </div>
                        </div>
                    </div>

                    {(AdjustmentListing.length === 0) && <div className="alert alert-info" >No records to display</div>}

                    {(AdjustmentListing.length > 0) && <div className="ws-12  allowVscroll">
                        <table className="table ws-12 " >
                            <thead>
                                <tr>
                                    <th className='text-bold'>Type</th>
                                    <th className='text-bold'>Percentage</th>
                                    <th className='text-bold'>Format/Source Codes</th>
                                    <th className='text-bold'>Region</th>
                                    <th className='text-bold'>Adjustment Amount</th>
                                    <th className='text-bold'>Adjustment Qty</th>
                                    <th className='text-bold forceSingleLine'>Operation</th>
                                </tr>
                            </thead>

                            <tbody>
                                {AdjustmentListing?.map((values: any) => {

                                    return (
                                        <tr>
                                            <td> {values.type}</td>
                                            <td> {values.percentage}</td>
                                            <td> {values.formatDesc}</td>
                                            <td> {values.groupDesc} ({values.territoryCode})</td>
                                            <td> {values.adjustAmount}</td>
                                            <td> {values.adjustQty}</td>
                                            <td >
                                                <a className="btn-sm icon-btn edit" onClick={() => selectAdjustment(values)}><i className="icon-edit1"></i></a>
                                                <a className="btn-sm icon-btn delete" onClick={() => onAdjustmentDelete(values)}><i className="icon-trashcan"></i></a>
                                            </td>
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>
                    </div>}

                    {
                        (() => {

                            if (deleteJob && deleteJob.adjustmentId) {
                                return <DeleteDialogueBox param={true} message={"delete region " + deleteJob.groupDesc + "(" + deleteJob.territoryCode + ")"} onChange={Confirmation} />
                            }
                        })()
                    }
                </div>
            </div>
        </div>

    );
}
